const RELATED_STUDY_URI = 'https://app.connect1d.ca/ext/relatedstudy';

export function parseStudyEntries(data, t) {
    const entries = data.entry || [];
    return entries
        .map(entry => {
            const resource = entry.resource;
            const studyExt = resource.extension?.find(ext => ext.url === RELATED_STUDY_URI);
            return {
                id: studyExt?.valueInteger,
                fhirId: resource.id,
                title: resource.title || t('admin.untitledStudy'),
                status: resource.status,
                date: resource.meta?.lastUpdated ? new Date(resource.meta.lastUpdated) : null,
            };
        })
        .filter(s => s.id != null);
}
